import axios, {AxiosResponse} from "axios";
import {APIS} from "../../../../static/apis";

export function validatePayeeVendorId (item: string, vendorId: string): Promise<AxiosResponse<{ data: string }>> {
  return axios.get(
    APIS.BASE_AUTH_MS_URL + APIS.VALIDATE_PAYEE_VENDOR_ID + "/" + item + "/" + vendorId
  );
}
